module.exports = __webpack_public_path__ + "static/mobile-banner-0063adb3782daeff5ee06ba6bb235563.svg";